module.exports = __webpack_public_path__ + "img/Chevron.aec1d835.svg";